import { createSlice } from '@reduxjs/toolkit'

/**
 * Redux slice, que maneja las acciones que modifican
 * el estado de las paginas de la aplicación.
 */
const analyticsSlice = createSlice({
  name: 'analytics',
  initialState: {
    cargaInicial: false,
    globalAnalytics: {},
    pageAnalytics: {},

    gaGlobal: {},
    clientesRecientes: [],
    gaActual: null
  },
  reducers: {
    /**
     * Acción que establece los clientes recientes de la página actual.
     * @param {Object} state - Estado actual del slice.
     * @param {Array} payload - Payload que contiene la información de los clientes.
     */
    getClientesRecientes: (state, { payload }) => {
      state.clientesRecientes = payload
    },

    getAnalygicsActual: (state, { payload }) => {
      state.gaActual = payload
    },

    getGlobalAnalytics: (state, { payload }) => {
      state.globalAnalytics = payload
    },
    getPageAnalytics: (state, { payload }) => {
      state.pageAnalytics = payload
    }
  }
})

export const { getClientesRecientes, getGlobalAnalytics, getPageAnalytics, getAnalyticsActual } = analyticsSlice.actions
export default analyticsSlice.reducer
